export const SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
